import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 682.7 682.7"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(".i519303598__st1{fill:none;stroke:#78ac47;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:13.3333}", -1)
      ])),
      _: 1,
      __: [0]
    })),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      "stroke-width": "26.6666",
      d: "M627.598 227.201c1.067 6.8 2.4 13.467 4.4 19.734 10 31.066 40.8 60.133 40.8 94.4s-30.8 63.466-40.8 94.4c-10.4 32.133-2.933 73.732-22.4 100.399-19.6 27.067-61.6 32.667-88.666 52.267-26.8 19.6-44.933 57.866-77.066 68.266-31.067 10.133-68.134-9.867-102.534-9.867-34.4 0-71.466 19.867-102.533 9.867-32.133-10.4-50.266-48.666-77.066-68.133-27.067-19.6-68.933-25.333-88.667-52.267-19.466-26.8-12-68.266-22.4-100.4-10-31.066-40.8-60.133-40.8-94.532 0-34.4 30.8-63.467 40.8-94.4 10.4-32.133 2.934-73.733 22.4-100.4 19.6-27.067 61.6-32.667 88.667-52.267 26.8-19.466 44.933-57.733 77.066-68.133 31.067-10.133 68.134 9.867 102.533 9.867 34.4 0 71.467-19.867 102.534-9.867 32.133 10.4 50.4 48.667 77.066 68.133 27.067 19.6 68.933 25.334 88.666 52.267 7.2 9.867 10.667 21.867 12.8 34.533",
      class: "i519303598__st1"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      "stroke-width": "26.6666",
      d: "M151.466 519.067C108 472.667 81.2 410.134 81.2 341.335c0-143.6 116.4-260.133 260.132-260.133 143.6 0 260.133 116.4 260.133 260.133S484.932 601.467 341.332 601.467c-58.266 0-112-19.066-155.332-51.466",
      class: "i519303598__st1"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      "stroke-width": "26.6666",
      d: "M439.466 304.801c9.466-24.8 59.733-1.733 72.533 8.4 10.933 8.534 7.733 26.534-5.467 30.667l-.4.133c-58.8 17.867-126-2.4-131.466-69.866-1.734-21.867.533-43.734 1.2-65.6",
      class: "i519303598__st1"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      "stroke-width": "26.6666",
      d: "M374 257.068c-.534 39.067-14.134 81.2-56.934 88.933-14.267 2.534-30.133 2.934-43.467-3.466m-24.133-140.267v95.733c0 23.2-18.8 42.134-42.133 42.134h-1.334c-23.2 0-42.133-18.8-42.133-42.134 0-12.8 4.8-25.6 17.067-31.333m110.133-39.733s34 12.8 32.8 50.133m-76.667 183.2 27.467-72c.533-1.334 2.533-1.334 3.067 0l27.2 72m-49.2-17.867h40.666M402 460.268l27.467-72c.533-1.334 2.533-1.334 3.066 0l27.2 72m-49.2-17.867H451.2m-110.8-55.2v72.933c.8.134 25.6 0 25.6 0m130-72.933v72.933c.8.134 25.6 0 25.6 0m-360.533-72.933v73.067m50.667-73.067v73.067m-50.667-37.734H211.6",
      class: "i519303598__st1"
    }, null, -1))
  ]))
}
export default { render: render }